import { applyDecorators, Post, Type, UseInterceptors } from '@nestjs/common';
import {
  ApiConflictResponse,
  ApiCreatedResponse,
  ApiForbiddenResponse,
  ApiInternalServerErrorResponse,
  ApiUnauthorizedResponse,
  ApiUnprocessableEntityResponse,
} from '@nestjs/swagger';

import { Roles } from '../../auth';
import { AutoReapInterceptor } from '../interceptors';

export const CreateResponse = <T extends Type>(path: string | string[], type?: T | [T], roles?: string[]) =>
  applyDecorators(
    ApiConflictResponse({ description: 'Conflict (409)' }),
    ApiCreatedResponse({ description: 'Created (201)', type }),
    ApiForbiddenResponse({ description: 'Forbidden (403)' }),
    ApiInternalServerErrorResponse({ description: 'Internal Server Error (500)' }),
    ApiUnauthorizedResponse({ description: 'Unauthorized (401)' }),
    ApiUnprocessableEntityResponse({ description: 'Unprocessable Entity (422)' }),
    Post(path),
    Roles(roles),
    UseInterceptors(AutoReapInterceptor)
  );
